var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#F3F1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#998CEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0068 10.1244L21.8749 11.9923M21.2078 8.47894L16.1543 13.5319C15.8932 13.7926 15.7152 14.1248 15.6426 14.4865L15.1758 16.8229L17.5123 16.3553C17.8741 16.2829 18.2059 16.1056 18.4671 15.8444L23.5205 10.7915C23.6724 10.6396 23.7928 10.4593 23.875 10.261C23.9572 10.0626 23.9995 9.84993 23.9995 9.63519C23.9995 9.42046 23.9572 9.20782 23.875 9.00943C23.7928 8.81104 23.6724 8.63078 23.5205 8.47894C23.3687 8.3271 23.1884 8.20665 22.99 8.12447C22.7916 8.0423 22.5789 8 22.3641 8C22.1494 8 21.9367 8.0423 21.7383 8.12447C21.5399 8.20665 21.3596 8.3271 21.2078 8.47894Z",
    stroke: "#363157",
    strokeWidth: 1.29411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2358 18.5886V21.2356C22.2358 21.7036 22.0499 22.1524 21.7189 22.4833C21.3879 22.8142 20.9391 23.0002 20.471 23.0002H10.7648C10.2967 23.0002 9.84785 22.8142 9.51689 22.4833C9.18593 22.1524 9 21.7036 9 21.2356V11.5302C9 11.0622 9.18593 10.6134 9.51689 10.2825C9.84785 9.95154 10.2967 9.76562 10.7648 9.76562H13.4119",
    stroke: "#363157",
    strokeWidth: 1.29411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3415e15a80957039191cbfae7f5f7ec6.svg";
export { ForwardRef as ReactComponent };